import React from 'react';
import { Box, ListItemIcon, ListItemText, List, ListItem, ListItemButton } from '@mui/material';
import { isActivePath } from './navItems';
import NavDrawerHeader from './NavDrawerHeader';
import NavDrawerUserInfo from './NavDrawerUserInfo';

const drawerItemSx = {
  borderRadius: 1,
  mx: 1,
  mb: 0.5,
  '&.Mui-selected': {
    bgcolor: 'primary.main',
    color: 'primary.contrastText',
    '&:hover': {
      bgcolor: 'primary.dark',
    },
    '& .MuiListItemIcon-root': {
      color: 'primary.contrastText',
    },
  },
};

/**
 * Inhoud van de mobiele navigatielade.
 * `items` is al gefilterd op rechten.
 */
export default function NavDrawerContent({ user, role, items, pathname, onClose, onNavigate }) {
  return (
    <Box
      sx={{
        height: '100%',
        bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <NavDrawerHeader onClose={onClose} />
      <NavDrawerUserInfo user={user} role={role} />

      <List sx={{ flexGrow: 1, px: 1 }}>
        {items.map(({ path, label, icon: Icon }) => (
          <ListItem key={path} disablePadding>
            <ListItemButton
              onClick={() => onNavigate(path)}
              selected={isActivePath(pathname, path)}
              sx={drawerItemSx}
            >
              <ListItemIcon>
                <Icon />
              </ListItemIcon>
              <ListItemText primary={label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
